import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex gap-3 mb-7 justify-center" }
const _hoisted_5 = ["id", "onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex gap-4 mb-7" }
const _hoisted_10 = ["id", "onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("a", { href: "#" }, [
        _createElementVNode("div", { class: "text-center mb-8" }, [
          _createElementVNode("img", {
            src: "/public/images/logo-wide.svg",
            class: "auth-logo"
          })
        ])
      ], -1)),
      (_ctx.step === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "font-semibold text-center my-6" }, "Vérification du code", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-read text-grey-600 text-center pb-5" }, " Saisissez le code de vérification à 6 chiffres envoyé à votre email ", -1)),
            _createElementVNode("form", {
              class: "form",
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.verifyOTP && _ctx.verifyOTP(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otpCode, (digit, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: index,
                    type: "text",
                    class: "form-control-code",
                    id: `otp-${index}`,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.otpCode[index]) = $event),
                    maxlength: "1",
                    onInput: ($event: any) => (_ctx.handleInput(index, $event, 'otp')),
                    onKeydown: ($event: any) => (_ctx.handleKeydown(index, $event, 'otp')),
                    onPaste: _cache[0] || (_cache[0] = (e) => _ctx.handlePaste(e, 'otp')),
                    placeholder: "",
                    inputmode: "numeric",
                    pattern: "[0-9]"
                  }, null, 40, _hoisted_5)), [
                    [_vModelText, _ctx.otpCode[index]]
                  ])
                }), 128))
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn lg w-100 flex-center mt-5 mb-4",
                disabled: !_ctx.isOtpComplete || _ctx.isSubmitting
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("img", {
                  src: "/public/icons/icon-valider.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Vérification...' : 'Vérifier'), 1)
              ], 8, _hoisted_6),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resendOTP && _ctx.resendOTP(...args))),
                class: "btn lg w-100 flex-center mb-7 btn-outline",
                disabled: _ctx.isResending
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.isResending ? 'Envoi en cours...' : 'Renvoyer le code'), 1)
              ], 8, _hoisted_7),
              _createVNode(_component_router_link, { to: "/auth/sign-in" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("h5", { class: "text-primary-color text-center" }, "Voulez-vous annuler ?", -1)
                ]))]),
                _: 1
              })
            ], 32)
          ]))
        : _createCommentVNode("", true),
      (_ctx.step === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "font-semibold text-center my-6" }, "Nouveau code de sécurité", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-read text-grey-600 text-center pb-5" }, " Votre code de sécurité sera utilisé pour vous permettre d'accéder à votre compte. ", -1)),
            _createElementVNode("form", {
              class: "form",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.securityCode, (digit, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: index,
                    type: "text",
                    class: "form-control-code",
                    id: `code-${index}`,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.securityCode[index]) = $event),
                    maxlength: "1",
                    onInput: ($event: any) => (_ctx.handleInput(index, $event, 'code')),
                    onKeydown: ($event: any) => (_ctx.handleKeydown(index, $event, 'code')),
                    onPaste: _cache[3] || (_cache[3] = (e) => _ctx.handlePaste(e, 'code')),
                    placeholder: "",
                    inputmode: "numeric",
                    pattern: "[0-9]"
                  }, null, 40, _hoisted_10)), [
                    [_vModelText, _ctx.securityCode[index]]
                  ])
                }), 128))
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "btn lg w-100 flex-center mt-5 mb-7",
                disabled: !_ctx.isCodeComplete || _ctx.isSubmitting
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("img", {
                  src: "/public/icons/icon-valider.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Enregistrement...' : 'Valider'), 1)
              ], 8, _hoisted_11)
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}